// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CompareIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CompareIcon" ref={forwardedRef} {...props}>
      <path d="M11.832 8.078 9.004 5.25l2.828-2.828 1.063 1.062L11.878 4.5h3.372a1 1 0 0 1 1 1v6.604a2.751 2.751 0 1 1-1.5 0V6h-2.878l1.02 1.02zM15.5 13.5a1.24 1.24 0 0 0-.78.274 1.25 1.25 0 0 0-.47.976 1.25 1.25 0 0 0 .47.976A1.25 1.25 0 1 0 15.5 13.5" />
      <path d="m7.918 11.922 2.828 2.828-2.828 2.828-1.063-1.062L7.872 15.5H4.75a1 1 0 0 1-1-1V7.896a2.751 2.751 0 1 1 1.5 0V14h2.628l-1.02-1.02zM4.5 6.5a1.24 1.24 0 0 0 .78-.274A1.25 1.25 0 0 0 5.75 5.25a1.25 1.25 0 0 0-.47-.976A1.25 1.25 0 1 0 4.5 6.5" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CompareIcon = /* @__PURE__ */ Object.assign(CompareIconComponent, {
  displayName: 'CompareIcon',
});
